import { ChevronDown } from "lucide-react";
import { Popover, PopoverContent, PopoverTrigger } from "./ui/popover";

export const MultiSelect = ({ placeholder, options, value, onChange, testid, groups = [] }) => {
  const toggle = (v) => onChange(value.includes(v) ? value.filter((x) => x !== v) : [...value, v]);
  const toggleGroup = (g) => {
    const all = g.values.every((v) => value.includes(v));
    onChange(all ? value.filter((v) => !g.values.includes(v)) : [...new Set([...value, ...g.values])]);
  };
  const labels = options.filter((o) => value.includes(o.value)).map((o) => o.label);
  const fullGroups = groups.filter((g) => g.values.length && g.values.every((v) => value.includes(v)));
  const rest = options.filter((o) => value.includes(o.value) && !fullGroups.some((g) => g.values.includes(o.value)));
  const summary = !value.length ? placeholder
    : [...fullGroups.map((g) => g.label), ...rest.map((o) => o.short || o.label)].join(", ") || labels.join(", ");
  return (
    <Popover>
      <PopoverTrigger asChild>
        <button type="button" className={`px-3 py-2.5 bg-[#F5F3ED] border border-[#E5E1D8] rounded-md text-sm text-left flex items-center justify-between gap-2 focus:outline-none focus:border-[#8C6C50] ${value.length ? "text-[#1A1A1A]" : "text-[#666]"}`} data-testid={testid}>
          <span className="truncate">{summary}</span>
          <ChevronDown className="w-4 h-4 shrink-0 text-[#8C6C50]" />
        </button>
      </PopoverTrigger>
      <PopoverContent align="start" className="w-72 p-2 max-h-80 overflow-y-auto" data-testid={`${testid}-menu`}>
        {value.length > 0 && (
          <button type="button" onClick={() => onChange([])} className="w-full text-left text-xs text-[#8C6C50] underline px-2 py-1" data-testid={`${testid}-clear`}>Tout désélectionner</button>
        )}
        {groups.map((g) => (
          <label key={g.label} className="flex items-center gap-2 px-2 py-2 rounded hover:bg-[#F5F3ED] cursor-pointer text-sm font-semibold border-b border-[#E5E1D8] mb-1">
            <input type="checkbox" checked={g.values.every((v) => value.includes(v))} onChange={() => toggleGroup(g)} className="accent-[#2B3029]" data-testid={`${testid}-group-${g.key}`} />
            {g.label}
          </label>
        ))}
        {options.map((o) => (
          <label key={o.value} className={`flex items-center gap-2 px-2 py-1.5 rounded hover:bg-[#F5F3ED] cursor-pointer text-sm ${o.indent ? "pl-6" : ""}`}>
            <input type="checkbox" checked={value.includes(o.value)} onChange={() => toggle(o.value)} className="accent-[#2B3029]" data-testid={`${testid}-opt-${o.value}`} />
            {o.label}
          </label>
        ))}
        {!options.length && <div className="text-xs text-[#666] px-2 py-2">Aucune option</div>}
      </PopoverContent>
    </Popover>
  );
};
